"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ExperimentContext_1 = __importDefault(require("./Experiment/ExperimentContext"));
var When = function (props) { return (react_1.default.createElement(ExperimentContext_1.default.Consumer, null, function (context) { return react_1.default.createElement(WhenRegister, __assign({ context: context }, props)); })); };
var WhenRegister = /** @class */ (function (_super) {
    __extends(WhenRegister, _super);
    function WhenRegister() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.checkForUpdate = function (bucket) {
            var _a = _this.props.context, _b = _a.currentExperiment, name = _b === void 0 ? '' : _b, _c = _a.experiments, experiments = _c === void 0 ? {} : _c, _d = _a.updateExperiment, updateExperiment = _d === void 0 ? function () { } : _d;
            var _e = (experiments[name] || {}).buckets, buckets = _e === void 0 ? null : _e;
            if (buckets && !buckets.includes(bucket)) {
                var previousValues = experiments[name];
                experiments[name] = __assign(__assign({}, previousValues), { buckets: buckets.concat([bucket]) });
                updateExperiment(name, experiments);
            }
        };
        return _this;
    }
    WhenRegister.prototype.componentDidMount = function () {
        var _this = this;
        var bucket = this.props.bucket;
        if (Array.isArray(bucket)) {
            bucket.map(function (b) { return _this.checkForUpdate(b); });
        }
        else {
            this.checkForUpdate(bucket);
        }
    };
    WhenRegister.prototype.render = function () {
        var _a = this.props, bucket = _a.bucket, _b = _a.render, render = _b === void 0 ? null : _b, children = _a.children, _c = _a.context, _d = _c.currentExperiment, currentExperiment = _d === void 0 ? '' : _d, _e = _c.experiments, experiments = _e === void 0 ? {} : _e;
        var _f = experiments[currentExperiment] || {}, _g = _f.isLoading, isLoading = _g === void 0 ? null : _g, _h = _f.assignedBucket, assignedBucket = _h === void 0 ? null : _h;
        var hasBucket = Array.isArray(bucket) && bucket && assignedBucket
            ? !!bucket.find(function (x) { return x === assignedBucket; })
            : assignedBucket === bucket;
        var canRender = hasBucket && !isLoading;
        if (!canRender)
            return null;
        return (react_1.default.createElement(react_1.default.Fragment, null, render ?
            render(__assign({}, experiments[currentExperiment])) : (react_1.default.createElement(react_1.default.Fragment, null, children))));
    };
    return WhenRegister;
}(react_1.PureComponent));
;
exports.default = When;
